module.exports = __webpack_public_path__ + "media/images/vr/games/azura/azura-mask-daf0c86c8dae3b60b51ce27cdfe0620a.jpg";